const notebookContent = {
    web: `Еще работая в аэропорту, я начал самостоятельно изучать веб-разработку. Через какое-то время понял,
    что хотел бы пройти полноценный курс. А уже через 10 месяцев получил диплом веб-разработчкика в Яндекс.Практикум`,
    hobby: `Свободное время я люблю проводить с автомобилем. А еще на моем балконе склад запчастей, и моя девушка обещает выкинуть
    все это добро в окно :) Мне нравится ухаживать за авто, ремонтирвать и ездить на нем разные в путешествия`
}

export default notebookContent
